import { mapAudioFormToTracksStore } from '../features/clips/domain/mappers/audio-form-to-clips/map-audio-form-to-tracks-store.ts'
import { fetchAudioFormUntilProcessed } from '../features/audio-form/domain/use-cases/generate-audioform.ts'
import useTracksStore from '../shared/store/tracks.store.tsx'
import useAudioStore from '../shared/store/audio.store.tsx'
import { AudioFormService } from '../features/audio-form/data/audio-form.service.ts'
import { stripBaseApiUrl } from '../utils/strip-base-api-url.ts'

export const loadAudioForm = async (id: string): Promise<void> => {
  const audioForm = await fetchAudioFormUntilProcessed(id)
  if (!audioForm.delivery.uri) {
    throw new Error('AudioForm delivery URI is missing')
  }

  const arrayBuffer = await AudioFormService.getArrayBuffer(
    stripBaseApiUrl(audioForm.delivery.uri)
  )

  const { audioContext } = useAudioStore.getState()
  const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)

  useTracksStore.getState().setGeneratedMix({
    id,
    url: audioForm.delivery.uri,
    audioBuffer,
  })

  await mapAudioFormToTracksStore(audioForm)
}
